export const MAX_VISIBLE_USER_GET_DOCUMENTS = 3;

export function generateUrlParams(nameVariableFromServer: string, objProps: any): string {
  let resString = "";
  for (let keyObj of Object.keys(objProps)) {
    if(objProps[keyObj] !== null && objProps[keyObj] !== undefined) {
      if (Array.isArray(objProps[keyObj])) {
        for (let elemArray of objProps[keyObj]) {
          resString += `${nameVariableFromServer}.${keyObj}=${elemArray}&`
        }
      } else
        resString += `${nameVariableFromServer}.${keyObj}=${objProps[keyObj]}&`;
    }
  }

  return resString;
}

export function getJoinUserNames(userNames: Array<string>) {
  let resultStr = "";
  if (userNames) {
    resultStr = userNames.slice(0, MAX_VISIBLE_USER_GET_DOCUMENTS).join(", ");
    if (userNames.length > MAX_VISIBLE_USER_GET_DOCUMENTS)
      resultStr += "...";
  }
  return resultStr
}
